module.exports = __webpack_public_path__ + "media/images/area/feature/prefecture/gunma_excellence/026-3c554bcd1651a803c1980b023c3ed02f.jpg";